// @todo create a function to generate automatically theses properties
// authorized lets you know if the token is true or not
export default {
  brands: state => state.brands || [],
  brand: state => state.brand || null,
};
